import React from 'react';
import { Card, Row } from 'antd';
import {VerticalLeftOutlined} from "@ant-design/icons";
import PropTypes from 'prop-types';
import './GraphicChip.css';

const GraphicChip = ({
                         imgUrl, title, tag, onClick, size, overlay,
                         backgroundSize='100% 200px',
                         showIcon=false,
                         textColor='#fff',
                         tagWeight='300',
                         tagColor='#fff',
                         tagBackground='rgba(0, 0, 0, 0.06)',
                        overlayCss



}) => {
  return (
    <div className="graphic-chip" onClick={onClick} style={{ width: size?.width || 240 }}>
      <Card
        bordered={false}
        hoverable
        className="graphic-chip-card"
        cover={
          <div
            className="graphic-chip-cover"
            style={{
              backgroundImage: `url(${imgUrl})`,
              height: size?.height || 120, // Default to 120 if height is not provided
              backgroundPosition: 'center center',
                backgroundSize:backgroundSize,
            }}
          >
            {/* Overlay div for optional rgba background fill */}
            {overlay && <div className="graphic-chip-overlay" style={{ backgroundColor: overlay, ... overlayCss || {} }}></div>}

            <div
                className="graphic-chip-title-overlay"
                style={{
                    textAlign: 'left',
                    color: textColor,
                }}
            >
                {title}
            </div>
                {tag && (
                        <div className="chip-tag"
                              style={{
                                      background: tagBackground,
                                      backdropFilter: 'blur(5px)',
                                      color: tagColor,
                                      fontFamily: "Quicksand, sans-serif",
                                      fontWeight: tagWeight
                              }}
                        >
                            {tag}
                        </div>
                )}
                {showIcon && (
                    <div className={'chip-icon'}>
                        <VerticalLeftOutlined style={{color: '#fff'}}/>
                    </div>
                )}

          </div>
        }
        bodyStyle={{ padding: 0 }}
      />
    </div>
  );
};

GraphicChip.propTypes = {
  imgUrl: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  tag: PropTypes.string,
  onClick: PropTypes.func,
  size: PropTypes.shape({
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
  overlayColor: PropTypes.string, // Adding PropTypes for the new prop
};

export default GraphicChip;
